import Layout, { Content, Footer } from 'antd/lib/layout/layout';
import StagingTag from 'components/StagingTag';
import React from 'react';

const BaseLayout: React.FC = ({ children }) => (
  <Layout className='gx-app-layout'>
    <StagingTag />
    <Layout>
      <Content className='gx-layout-content gx-container-wrap'>{children}</Content>
      <Footer>
        <div className='gx-layout-footer-content'>Copyright NotarizeMe © 2021</div>
      </Footer>
    </Layout>
  </Layout>
);

export const withBaseLayout = (Component: React.FC) => (props: any) => (
  <BaseLayout>
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <Component {...props} />
  </BaseLayout>
);

export default BaseLayout;
